import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { TrendingUp, Network, Building2, Users, FileText } from 'lucide-react';
import UsageBar from './UsageBar';

export default function UsageCard({ usage, isProvider }) {
  if (!usage) return null;
  return (
    <Card data-testid="usage-card">
      <CardHeader className="pb-3">
        <div className="flex items-center gap-2">
          <TrendingUp className="w-5 h-5 text-blue-500" />
          <CardTitle className="text-lg">Usage</CardTitle>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        {isProvider && usage.organizations && (
          <UsageBar label="Organizations" current={usage.organizations.current} limit={usage.organizations.limit} icon={Network} />
        )}
        <UsageBar label="Companies" current={usage.companies.current} limit={usage.companies.limit} icon={Building2} />
        <UsageBar label="Admins" current={usage.admins.current} limit={usage.admins.limit} icon={Users} />
        <UsageBar label="Users" current={usage.users.current} limit={usage.users.limit} icon={Users} />
        <UsageBar label="Claims This Month" current={usage.claims_this_month.current} limit={usage.claims_this_month.limit} icon={FileText} />
      </CardContent>
    </Card>
  );
}
